import ReactMarkdown from 'react-markdown';

import { cn } from 'utils/cn';

export interface MarkdownProps {
  text: string;
  className?: string;
}

const Markdown = ({ text, className }: MarkdownProps) => {
  return (
    <div
      className={cn(
        '[&_ol]:pl-4 [&_ul]:pl-4 [&_li]:ml-4 [&_strong]:font-medium',
        className
      )}
    >
      <ReactMarkdown
        components={{
          a(props) {
            const { children, className, node, ...rest } = props;
            return (
              <a
                {...rest}
                className={cn(
                  'text-primary font-medium underline underline-offset-4',
                  className
                )}
                target="_blank"
                rel="noopener noreferrer"
              >
                {children}
              </a>
            );
          },
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
};

export { Markdown };
